import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-100 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-heading text-xl font-bold uppercase text-slate-900">COACH.</Link>
          <Link to="/" className="text-sm text-slate-500 hover:text-blue-600 flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight uppercase text-slate-900 mb-8">Mentions L&eacute;gales</h1>

        <div className="space-y-8 text-sm text-slate-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">&Eacute;diteur du site</h2>
            <p>Le site Coach est &eacute;dit&eacute; par :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Nom : Anthony Gillet</li>
              <li>Statut : Entrepreneur individuel</li>
              <li>Contact : via le formulaire de support disponible sur la plateforme</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">H&eacute;bergeur</h2>
            <p>Le site est h&eacute;berg&eacute; par :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>LWS (Ligne Web Services)</li>
              <li>Adresse : 10 Rue de Penthi&egrave;vre, 75008 Paris, France</li>
              <li>Site web : <a href="https://www.lws.fr" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-700">www.lws.fr</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Propri&eacute;t&eacute; intellectuelle</h2>
            <p>
              L'ensemble du contenu du site Coach (textes, images, graphismes, logo, ic&ocirc;nes, logiciels, etc.) est la propri&eacute;t&eacute;
              exclusive d'Anthony Gillet ou de ses partenaires. Toute reproduction, repr&eacute;sentation, modification, publication,
              transmission ou d&eacute;naturation, totale ou partielle, du site ou de son contenu, par quelque proc&eacute;d&eacute; que ce soit,
              et sur quelque support que ce soit, est interdite sans l'autorisation &eacute;crite pr&eacute;alable d'Anthony Gillet.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Limitation de responsabilit&eacute;</h2>
            <p>
              Anthony Gillet s'efforce de fournir des informations aussi pr&eacute;cises que possible sur la plateforme Coach.
              Toutefois, il ne pourra &ecirc;tre tenu responsable des omissions, des inexactitudes et des carences dans la mise &agrave; jour,
              qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
            </p>
            <p className="mt-2">
              Les conseils de coaching sportif et nutritionnel fournis via la plateforme ne se substituent pas &agrave; un avis m&eacute;dical.
              Il est recommand&eacute; de consulter un professionnel de sant&eacute; avant de commencer tout programme d'entra&icirc;nement ou r&eacute;gime alimentaire.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Droit applicable</h2>
            <p>
              Les pr&eacute;sentes mentions l&eacute;gales sont r&eacute;gies par le droit fran&ccedil;ais. En cas de litige, et apr&egrave;s tentative de
              r&eacute;solution amiable, comp&eacute;tence est attribu&eacute;e aux tribunaux fran&ccedil;ais comp&eacute;tents.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-slate-100 py-6 px-6">
        <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-4 text-xs text-slate-400">
          <Link to="/mentions-legales" className="hover:text-blue-600">Mentions l&eacute;gales</Link>
          <span>&middot;</span>
          <Link to="/politique-confidentialite" className="hover:text-blue-600">Politique de confidentialit&eacute;</Link>
          <span>&middot;</span>
          <Link to="/cgu" className="hover:text-blue-600">CGU</Link>
        </div>
      </footer>
    </div>
  );
}
